import moment from 'moment';

import { RelativeTime } from '../../RelativeTime';
import { Time } from '../../Time';

interface AgenticChatSessionUpdatedTimeProps {
  when: string;
}

export function AgenticChatSessionUpdatedTime(props: AgenticChatSessionUpdatedTimeProps) {
  const { when } = props;

  return moment(when).isAfter(moment().subtract(7, 'days')) ? (
    <RelativeTime when={when} />
  ) : (
    <Time when={when} format="date" />
  );
}
